module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2020/july-39477d1819673b3d683329c8b3a09f33.png";